webpackJsonp([70144966829960],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    "form",
	    { className: "mx-auto md:w-1/2" },
	    _react2.default.createElement(
	      "p",
	      { className: "leading-loose mb-8" },
	      "Here is an example of a form built using Tailwind. Click",
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          href: "https://tailwindcss.com/docs/examples/forms",
	          className: "font-bold no-underline text-grey-darkest"
	        },
	        "here"
	      ),
	      " ",
	      "to see more examples."
	    ),
	    _react2.default.createElement(
	      "label",
	      {
	        className: "block font-bold mb-2 text-xs uppercase",
	        htmlFor: "first-name"
	      },
	      "First Name"
	    ),
	    _react2.default.createElement("input", {
	      className: "appearance-none block bg-grey-lighter mb-6 p-3 rounded-md text-grey-darker w-full",
	      id: "first-name",
	      type: "text",
	      placeholder: "Bill"
	    }),
	    _react2.default.createElement(
	      "label",
	      {
	        className: "block font-bold mb-2 text-xs uppercase",
	        htmlFor: "last-name"
	      },
	      "Last Name"
	    ),
	    _react2.default.createElement("input", {
	      className: "appearance-none block bg-grey-lighter mb-6 p-3 rounded-md text-grey-darker w-full",
	      id: "last-name",
	      type: "text",
	      placeholder: "Murray"
	    }),
	    _react2.default.createElement(
	      "label",
	      { className: "block font-bold mb-2 text-xs uppercase", htmlFor: "message" },
	      "Message"
	    ),
	    _react2.default.createElement("textarea", {
	      className: "appearance-none bg-grey-lighter mb-6 p-3 rounded-md text-grey-darker w-full",
	      placeholder: "Say something...",
	      rows: "8"
	    }),
	    _react2.default.createElement(
	      "button",
	      { className: "border-b-4 border-grey-darker hover:border-grey-dark bg-grey-dark hover:bg-grey font-bold px-6 py-3 rounded text-sm text-white" },
	      "Submit"
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-d5b26e7f7c5ef2669134.js